import { GetCookie } from "./CookieControl/CookieUtil";
import { InitLazyEmbed } from "./LazyEmbed";
import { debounce } from "./Util";
import { BreakPoint } from "./UI/BreakPoint";
class WebUtils {
    InitGlobalUtils() {
        this.breakPoint = new BreakPoint();
        $.ajaxSetup({
            cache: false,
            beforeSend: function (xhr) {
                const token = GetCookie("XSRF-TOKEN");
                xhr.setRequestHeader("RequestVerificationToken", token);
            }
        });
        InitLazyEmbed();
    }
    SetMobileMenuButtonToggle(breakpoint = 1000) {
        this.SetMobileMenuButtonVisibility(breakpoint);
        $(window).on("resize", () => this.SetMobileMenuButtonVisibility(breakpoint));
    }
    SetMobileMenuButtonVisibility(breakpoint) {
        const $menuSelector = $(".caller");
        const $target = $("#" + $menuSelector.attr("aria-controls"));
        if ($target.length) {
            if ($(window).width() < breakpoint) {
                $menuSelector.attr("aria-hidden", "false").attr("aria-expanded", "false");
                $target.attr("aria-hidden", "true");
            }
            else {
                $menuSelector.attr("aria-hidden", "true").attr("aria-expanded", "false");
                $target.attr("aria-hidden", "false");
            }
        }
    }
    HasRecaptcha() {
        return !!window.grecaptcha;
    }
    InitInteractionComponents() {
        this.RecaptchaKey = $("#recaptchaSiteKey").val();
        this.UpdateFormsToken();
        this.SetupEvents();
    }
    UpdateFormsToken() {
        const token = GetCookie("XSRF-TOKEN");
        if (token) {
            $("form").each((idx, elem) => {
                const $form = $(elem);
                if ($form.find("[name=__RequestVerificationToken]").length > 0) {
                    $form.find("[name=__RequestVerificationToken]").remove();
                }
                $form.append(`<input name="__RequestVerificationToken" type="hidden" value="${token}">`);
            });
        }
    }
    RenderRecaptchas() {
        if (!this.RecaptchaKey || !window.grecaptcha) {
            return;
        }
        $(".g-recaptcha").each((i, e) => {
            this.RenderRecaptcha(e);
        });
    }
    RenderRecaptcha(e) {
        try {
            if (!window.grecaptcha) {
                return;
            }
            const $e = $(e);
            if (!$e.attr("data-RecaptchaWidgetId")) {
                const params = { "sitekey": this.RecaptchaKey };
                const recaptchaWidgetId = window.grecaptcha.render((e), params);
                $e.attr("data-RecaptchaWidgetId", recaptchaWidgetId + "");
            }
        }
        catch (e) {
            console.log(e);
        }
    }
    ResetCaptcha(recaptchaWidgetId) {
        if (!window.grecaptcha) {
            return;
        }
        try {
            window.grecaptcha.reset(recaptchaWidgetId);
        }
        catch (e) {
        }
    }
    GetCaptchaResponse(recaptchaWidgetId) {
        if (!window.grecaptcha) {
            return;
        }
        return window.grecaptcha.getResponse(recaptchaWidgetId);
    }
    SetupEvents() {
        $("body").on("click", "[aria-controls]", (ev) => {
            const $caller = $(ev.currentTarget);
            if ($caller.hasClass('no-toggle-action')) {
                return;
            }
            const tagName = $caller.prop("tagName").toLowerCase();
            const type = $caller.attr("type");
            if (!(tagName === "input" && (type === "checkbox" || type === "radio"))) {
                ev.stopImmediatePropagation();
                ev.preventDefault();
            }
            const $target = $("#" + $caller.attr("aria-controls"));
            this.ToggleDisplay($caller, $target);
        });
        $(document).on("mouseup", (ev) => {
            this.OnMouseUp(ev);
        });
        $(window).on("resize", debounce(() => this.OnWindowResize(), 500));
    }
    OnWindowResize() {
        this.breakPoint.RefreshValue();
    }
    OnMouseUp(ev) {
        const $target = $(ev.target);
        if (!$target.attr("aria-controls") && !$target.parent().attr("aria-controls") && $target.closest(".autoclose").length === 0) {
            const $autoClosedContainer = $(".autoclose[aria-hidden='false']");
            const $caller = $("[aria-controls=" + $autoClosedContainer.attr("id") + "]");
            this.ToggleDisplay($caller, $autoClosedContainer);
        }
    }
    ToggleDisplay($caller, $target) {
        $(".autoclose[aria-hidden='false']").each((i, e) => {
            if (e !== $target.get(0) && $target.closest(".autoclose").get(0) !== e) {
                const $e = $(e);
                $e.attr("aria-hidden", "true");
                $("[aria-controls=" + $e.attr("id") + "]").attr("aria-expanded", "false");
            }
        });
        this.ToggleAriaExpansion($caller);
        if ($caller.attr("aria-expanded") === "true") {
            $target.attr("aria-hidden", "false");
            setTimeout(() => {
                $target.find("input[type=text],input[type=search],input[type=email]").first().trigger("focus");
            }, 300);
        }
        else {
            $target.attr("aria-hidden", "true");
        }
    }
    ToggleAriaExpansion($element) {
        if ($element.attr("aria-expanded") === "true") {
            $element.attr("aria-expanded", "false");
        }
        else {
            $element.attr("aria-expanded", "true");
        }
    }
    SetUpVideoPlayer($container) {
        const videos = $container.find("video:visible");
        if (videos.length) {
            videos.mediaelementplayer({
                startLanguage: 'en'
            });
        }
    }
}
export const WebAppUtils = new WebUtils();
//# sourceMappingURL=WebApplicationHelper.js.map